import styled from "styled-components";

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0%;
  color: ${({ theme }) => theme.colors.text};
  padding: 10px 20px;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .suitcase-guy {
    transform: scale(2);
    position: absolute;
    bottom: 70px;
    right: 60px;
    z-index: -9;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      transform: scale(1);
      right: initial;
      bottom: 0px;
    }
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
  position: absolute;
  top: 20px;
  left: 40px;
  font-size: 24px;
  z-index: 9999;
  .go-back {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    img {
      height: 24px;
      filter: ${({ theme }) =>
        theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
    }
  }
`;

export const Label = styled.p`
  font-size: 14px;
  margin-bottom: 6px;
`;

export const Input = styled.input`
  min-width: 100%;
  width: 100%;
  height: 50px;
  border-radius: 8px;
  border: 0.5px solid rgba(0, 0, 0, 0.3);
  background-color: ${({ theme }) => theme.colors.card};
  color: ${({ theme }) => theme.colors.text};
  box-sizing: border-box;
  padding: 16px;
  margin: 6px 0 12px 0;
  &:focus {
    outline: 1px solid black;
  }
`;

export const ErrorMessage = styled.div`
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;
  color: #ef6469;
  width: 100%;
  text-align: center;
`;
